
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default [
  {
    // 未匹配到页面 --> 社会招聘
    path: '*',
    redirect: '/job/list/social',
  },
  // 职位列表（社会招聘）
  {
    path: '/job/list/social', name: 'JobListSocial', component: _import('job/list'),
    meta: { title: '社会招聘', type: 'social', headerDark: true }
  },
  // 职位列表（校园招聘）
  {
    path: '/job/list/campus', name: 'JobListCampus', component: _import('job/list'),
    meta: { title: '校园招聘', type: 'campus', headerDark: true }
  },
  // 职位详情
  {
    path: '/job/detail/:jobId', name: 'JobDetail', component: _import('job/detail'),
    meta: { title: '职位详情' }
  },
  // 校园行程列表
  {
    path: '/schedule/list', name: 'ScheduleList', component: _import('schedule/list'),
    meta: { title: '校园行程', headerDark: true }
  },
  // 行程详情
  {
    path: '/schedule/detail/:id', name: 'ScheDuleDetail', component: _import('schedule/detail'),
    meta: { title: '行程详情' }
  },
  // 校园行程报名
  {
    path: '/schedule/apply', name: 'ScheDuleApply', component: _import('schedule/apply'),
    meta: { title: '校园行程报名' }
  },
  // 个人中心
  {
    path: '/mine', name: 'Mine', component: _import('mine'),
    meta: { title: '个人中心' }
  },
  // 职位收藏列表
  {
    path: '/mine/job_collect', name: 'JobCollect', component: _import('mine/job_collect'),
    meta: { title: '职位收藏' }
  },
  // 投递记录
  {
    path: '/submit_record', name: 'SubmitRecord', component: _import('mine/submit_record'),
    meta: { title: '投递记录' }
  },
  // 我的简历
  {
    path: '/resume', name: 'Resume', component: _import('resume'),
    meta: { title: '我的简历' }
  },
  // 填写个人信息
  {
    path: '/userInfo/:info', name: 'UserInfo', component: _import('resume/userInfo'),
    meta: { title: '编辑个人信息' }
  },
  // 教育经历
  {
    path: '/resume/education/:info', name: 'ResumeEducation', component: _import('resume/education'),
    meta: { title: '教育经历' }
  },
  // 工作经历
  {
    path: '/resume/work/:workId?', name: 'ResumeWork', component: _import('resume/work'),
    meta: { title: '工作经历'}
  },
  // 工作经历-工作内容
  {
    path: '/resume/content/:workId?', name: 'ResumeWorkContent', component: _import('resume/work/content'),
    meta: { title: '编辑工作内容'}
  },
  // 工作经历-工作业绩
  {
    path: '/resume/achievement/:workId?', name: 'ResumeWorkAchievement', component: _import('resume/work/achievement'),
    meta: { title: '编辑工作业绩'}
  },
  // 授权失败
  {
    path: '/loginerror', name: 'LoginError', component: _import('system/loginerror'),
    meta: { title: '网络错误'}
  },
]
